import React, { createRef, useEffect } from 'react';

interface TransactionLoadingSVGInt {
  changeAnimation: (x: boolean) => void;
  loading: boolean;
}

interface SVGAnimationElement extends SVGSVGElement {
  beginElement(): SVGElement;
}

const TransactionLoadingSVG: React.FC<TransactionLoadingSVGInt> = ({
  loading,
  changeAnimation
}) => {
  const circleAnimationRef = createRef<SVGAnimationElement>();
  const strokeAnimationRef = createRef<SVGAnimationElement>();
  const dashedLineAnimationRef = createRef<SVGAnimationElement>();

  useEffect(() => {
    circleAnimationRef.current?.addEventListener('endEvent', () => {
      if (loading) {
        circleAnimationRef.current?.beginElement();
        strokeAnimationRef.current?.beginElement();
        dashedLineAnimationRef.current?.beginElement();
      } else {
        changeAnimation(true);
      }
    });
  }, [circleAnimationRef, strokeAnimationRef, dashedLineAnimationRef, loading, changeAnimation]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="TransactionLoadingSVG"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 3000 1000"
    >
      <g id="Circle" opacity="1" transform="translate(2497.31826, 504) scale(0.59333,0.59333) ">
        <g id="Shape-Layer-2" opacity="1" transform="rotate(-90)">
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            values="-90;630;-90;630;-90;629.762799"
            keyTimes="0;0.333421;0.333684;0.666842;0.667105;1"
            dur="3.8s"
            repeatCount="1"
            fill="freeze"
            ref={circleAnimationRef}
          />
          <g id="Ellipse-1" opacity="1" transform="scale(1.51614,1.51614)">
            <path
              id="Ellipse-Path-1"
              fill="none"
              d="M0,-260.54C143.892,-260.54,260.54,-143.892,260.54,0C260.54,143.892,143.892,260.54,0,260.54C-143.892,260.54,-260.54,143.892,-260.54,0C-260.54,-143.892,-143.892,-260.54,0,-260.54Z"
              stroke="#02bd9c"
              strokeOpacity="1"
              strokeWidth="40"
              strokeMiterlimit="4"
              strokeLinecap="round"
              strokeLinejoin="miter"
              strokeDasharray="1636.59"
              strokeDashoffset="1634.89"
            >
              <animate
                attributeName="stroke-dashoffset"
                values="1634.89;799.059;1634.89;1634.89;799.059;1634.89;1634.89;799.059;1634.89"
                keyTimes="0;0.175526;0.333421;0.333684;0.508947;0.666842;0.667105;0.842368;1"
                calcMode="spline"
                keySplines="0.494726 0 0.58 1;0.42 0 0.58 1;0 0 0 0;0.494726 0 0.58 1;0.42 0 0.58 1;0 0 0 0;0.494726 0 0.58 1;0.420144 0 0.580543 0.997359"
                dur="3.8s"
                repeatCount="1"
                fill="freeze"
                ref={strokeAnimationRef}
              />
            </path>
          </g>
        </g>
      </g>
      <g
        id="Wallet"
        transform="translate(533.5,487.5) scale(0.41313,0.41313) translate(-647.5,-647.5)"
      >
        <g id="Path-5" opacity="1">
          <path
            id="Path-1"
            fill="#000000"
            d="M1241.04,431.666C1241.04,431.666,1187.08,431.666,1187.08,431.666C1187.08,431.666,1187.08,323.75,1187.08,323.75C1187.08,294.072,1162.8,269.791,1133.12,269.791C1133.12,269.791,952.365,269.791,952.365,269.791C952.365,269.791,842.29,31.295,842.29,31.295C833.063,11.871,813.152,0,792.108,0C784.554,0,777,1.618,769.985,4.856C769.985,4.856,154.86,269.791,154.86,269.791C154.86,269.791,53.958,269.791,53.958,269.791C24.281,269.791,0,294.072,0,323.75C0,323.75,0,1241.04,0,1241.04C0,1270.72,24.281,1295,53.958,1295C53.958,1295,1241.04,1295,1241.04,1295C1270.72,1295,1295,1270.72,1295,1241.04C1295,1241.04,1295,485.625,1295,485.625C1295,455.947,1270.72,431.666,1241.04,431.666ZM1133.12,323.75C1133.12,323.75,1133.12,431.666,1133.12,431.666C1133.12,431.666,1023.59,431.666,1023.59,431.666C1023.05,426.81,1022.51,421.954,1020.35,417.098C1020.35,417.098,977.185,323.75,977.185,323.75C977.185,323.75,1133.12,323.75,1133.12,323.75ZM53.958,371.772C53.958,371.772,165.652,323.75,165.652,323.75C165.652,323.75,290.835,269.791,290.835,269.791C290.835,269.791,791.569,53.958,791.569,53.958C791.569,53.958,793.188,53.958,793.188,53.958C793.188,53.958,893.604,269.791,893.604,269.791C893.604,269.791,918.91,323.75,918.91,323.75C918.91,323.75,968.552,431.666,968.552,431.666C968.552,431.666,81.477,431.666,81.477,431.666C81.477,431.666,53.958,372.312,53.958,372.312C53.958,372.312,53.958,371.772,53.958,371.772ZM1241.04,909.197C1241.04,909.197,1098.05,909.197,1098.05,909.197C1058.12,909.197,1025.21,876.283,1025.21,836.354C1025.21,836.354,1025.21,820.166,1025.21,820.166C1025.21,780.237,1058.12,747.322,1098.05,747.322C1098.05,747.322,1241.04,747.322,1241.04,747.322C1241.04,747.322,1241.04,909.197,1241.04,909.197ZM1241.04,693.364C1241.04,693.364,1098.05,693.364,1098.05,693.364C1027.91,693.364,971.25,750.02,971.25,820.166C971.25,820.166,971.25,836.354,971.25,836.354C971.25,905.96,1027.91,963.156,1098.05,963.156C1098.05,963.156,1241.04,963.156,1241.04,963.156C1241.04,963.156,1241.04,1241.04,1241.04,1241.04C1241.04,1241.04,53.958,1241.04,53.958,1241.04C53.958,1241.04,53.958,485.625,53.958,485.625C53.958,485.625,1241.04,485.625,1241.04,485.625C1241.04,485.625,1241.04,693.364,1241.04,693.364Z"
            fillOpacity="1"
            fillRule="nonzero"
          />
        </g>
      </g>
      <g id="ProgressBar" transform="translate(1682,514)">
        <g id="Shape-1" opacity="1">
          <path
            id="Path-1-2"
            fill="none"
            d="M-732,-14C-732,-14,-732,-14,-732,-14"
            stroke="#02bd9c"
            strokeOpacity="1"
            strokeWidth="30"
            strokeMiterlimit="4"
            strokeLinecap="round"
            strokeLinejoin="miter"
            strokeDasharray="105"
            strokeDashoffset="0"
          >
            <animate
              attributeName="d"
              values="M-732,-14C-732,-14,-732,-14,-732,-14;M-732,-14C-732,-14,418,-14,418,-14"
              keyTimes="0;1"
              dur="3.8s"
              repeatCount="1"
              fill="freeze"
              ref={dashedLineAnimationRef}
            />
          </path>
        </g>
      </g>
    </svg>
  );
};

export default TransactionLoadingSVG;
